import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class CodesFaultRoute extends AuthenticatedRoute {}
